import { createAvatar, Options } from '@dicebear/core'
import { bottts, botttsNeutral, icons, thumbs, funEmoji } from '@dicebear/collection'
import { useMemo, useState } from 'react'

interface UseGenerateAvatarProps {
   roleID: string
}

type UseGenerateAvatarReturn = {
   generatedAvatars: string[]
   generateNewAvatars: () => void
}

const useGenerateAvatar = (props: UseGenerateAvatarProps): UseGenerateAvatarReturn => {
   const { roleID } = props
   const [randomNumber, setRandomNumber] = useState<number>(0)
   const [generatedAvatars, setGeneratedAvatars] = useState<string[]>([])

   useMemo(() => {
      const generalOptions: Options = {
         seed: roleID + randomNumber.toString(),
      }
      const avatars = async () => {
         const avatar1 = await createAvatar(bottts, generalOptions).png().toDataUri()
         const avatar2 = await createAvatar(botttsNeutral, generalOptions).png().toDataUri()
         const avatar3 = await createAvatar(icons, generalOptions).png().toDataUri()
         const avatar4 = await createAvatar(thumbs, generalOptions).png().toDataUri()
         const avatar6 = await createAvatar(funEmoji, generalOptions).png().toDataUri()

         setGeneratedAvatars([avatar1, avatar2, avatar3, avatar4, avatar6])
      }
      avatars()
   }, [randomNumber])

   const generateNewAvatars = () => {
      setRandomNumber(Math.floor(Math.random() * 10))
   }

   return {
      generateNewAvatars,
      generatedAvatars,
   }
}

export default useGenerateAvatar
